import styled from 'styled-components';

export const Container = styled.div`
        position: absolute;
        width: 100%;
        height: 240px;
        top: 0;
        left: 0;
        right: 0;
        z-index: 0;
        background: linear-gradient(135deg, #0a0e27 0%, #0f3460 40%, #00d4ff 80%, #0099cc 100%);
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);

    :after {
                position: absolute;
                width: 100%;
                height: 100%;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                content: '';
                background: inherit;
                transform-origin: top right;
                ${(props) => props.isDiagonal ? 'transform: skewY(-3deg);' : ''};
        }
`;
